import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ModelRestService } from '../../model-rest.service';
import { WebPayNotification } from '../../model/WebPayNotification';
import { RouteBooking } from '../../model/routebooking';
import { Response } from '../../model/response';
declare var $: any;

declare function PixelConversion( PurchasePrice, PurchaseCurrency, ConfirmationNumber,
                  DepartureDate, ReturnDate, DestinationCity, DestinationStateorRegion, 
                  DestinationCountry, AttractionName, NumberOfTravelers):any;

function gtag(...args: any[]){
  window['datalayer'].push(arguments);
}

/**Componente donde se valida si el pago fue satisfactorio o no */
@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
  content = {
    'title': '',
    'main': '',
    'extra': '',
    'reference': '',
    'operation_num': '',
    'auth_num': '',
    'code_resp': '',
    'nbError' : '',
    'amount' : '',
    'nombre' : '',
    'num_tarjeta' : '',
    'tipo_tarjeta' : '',
    'moneda' : ''
  };
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private model:ModelRestService, 
  ) { }
  /**Se hace la validación del pago, si es satisfactoria la respuesta se muestra el modal de pago exitoso, de lo contrario se mostrara el modal de rechazado */
  
  public ejecutaPixel:boolean;
  public amountP:string;
  public reference:string;

  ngOnInit() {
    // Obtenemos parametros de pago
    this.ejecutaPixel = false;
    console.clear();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const nbResponse = params['nbResponse'];
      var referencia:number = params['referencia'];
      const operacion = params['operacion'];
      const nuAut = params['nuAut'];
      const nbError = params['nb_error'];
      const cdResponse = params['cdResponse'];
      var amount:string = params['importe'];
      var nombre:string;// = params['nombre'];
      var numTarjeta:string;// = params['num_tarjeta'];
      var tipoTarjeta:string = params['banco'];
      var moneda:string;// = params['moneda'];

      var wpNotif : WebPayNotification; 
      this.model.getPaymentNotification(referencia).subscribe((response:any) => {        
      
            wpNotif = response.data;  
            amount = amount;
            numTarjeta = wpNotif.cc_number;
            tipoTarjeta = tipoTarjeta;
            moneda = "MXN";  
            this.ejecutaPixel = true;
            this.amountP = amount;
            this.reference = referencia.toString();

              // Si nbResponse = “Aprobado” y nuAut != “”
            //try{ this.pixel();}catch(error){}

            if (nbResponse === 'Aprobado' && nuAut !== '') {
              this.content.title = 'Cobro Aprobado';
              this.content.reference = referencia.toString();
              this.content.nombre = nombre;
              this.content.amount = amount;
              this.content.moneda = moneda;
              this.content.num_tarjeta = numTarjeta;
              this.content.tipo_tarjeta = tipoTarjeta;
              this.content.auth_num = nuAut;
              this.content.operation_num = operacion;

              this.content.main = 'En breve recibirás tus boletos electrónicos <br /> y clave de reservación por correo electrónico.';
              this.content.extra = 'Te recomendamos imprimas tus boletos y los lleves <br/>contigo el día que vayas a abordar el tren. <br/>Gracias por tu preferencia';

              try{this.pixel(); }catch(error)
              {}

              try{
                gtag('event', 'purchase', {
                  send_to: 'G-QLY5H41M9F',
                  transaction_id : operacion,
                  value : amount,
                  currency : moneda
                });     
            
              }catch{}
            }

            // Si nbResponse = “Rechazado”
            else if (nbResponse === 'Rechazado') {
              try{
                gtag('config', 'G-QLY5H41M9F', { 'page_path': '/Express/conversionERROR' });
                gtag('config', 'UA-117757515-1', { 'page_path': '/Express/conversionERROR' });
              }catch{}

              this.content.title = 'Cobro declinado';
              this.content.main = 'No se realizó ningún cargo a su tarjeta';
              this.content.extra = 'La operación fue declinada por su banco emisor.\n Favor de intentar con otra tarjeta';
              this.content.code_resp = cdResponse;
              this.content.nbError = nbError;
              this.content.amount;
              this.content.num_tarjeta;
              this.content.title;
              this.content.nombre;
              this.content.moneda;
            }

            else{
              this.content.title = 'Lo sentimos, no podemos procesar el pago.';
              this.content.main = 'Favor de intentar mas tarde o contactar a nuestra área de Atención al Cliente.';
              this.content.extra = '';
            }
      });
    });
  }


  private pixel(){
    try{

      
      this.model.paymentinfoPixel(this.reference).subscribe((response: Response<RouteBooking>) => {

     
        if (response.status.message == 'OK') {
          var response2 = response.data;     
          
          var claseStr = "";
          switch (response2.etickets_contact_lastName) {
            case "6":
              claseStr = "Express Primera";
              break;
            case "5":
              claseStr = "Express Turista";
              break;
            case "4":
              claseStr = "Express Ejecutiva";
              break;
          }

              
        
          PixelConversion( this.amountP, "MXN", this.reference,
          response2.etickets_email,
          response2.etickets_phone,
          response2.etickets_emergency_contact,
          response2.etickets_contact_firstName,
          "Mexico",         
          claseStr,response2.observaciones);

          try{
            gtag('event', 'purchase', {
              'event_label': this.reference,
              'event_category': 'ecommerce',
              'event_value': this.amountP,}
            );            
          }catch{}
        } 
  
      });


    }catch(error){
      console.log(error);

    }

  }

}
